const trimLevels = {
  TRIM: 'trim',
  DOM_ID_PREFIX: 'trim_levels_',
};

export default trimLevels;
